import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";

export class BehaviorBase {
    public Control:PDFControlBase;

    public SetPDFControlBase(control:PDFControlBase)
    {
        this.Control=control;
    }

    public get IsDraggable(){
        return true;
    }

    OnGenerate(container: HTMLElement) {

    }

    OnSelect() {

    }

    OnDeSelect() {

    }
}